import * as React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { graphql } from "react-apollo";
import { gql } from "apollo-boost";
import Moment from "react-moment";
import * as colors from "../../../settings/colors";
import { contactDisplayName } from "../../../utils/helpers";

import CenteredLoader from "../../CenteredLoader";
import { Table, TableRow, TableCell } from "../../Table";
import EmptyMessage from "../../EmptyMessage";

const StyledLink = styled(Link)`
  color: ${colors.TEXT};
  text-decoration: none;
  font-weight: 600;

  &:hover {
    color: ${colors.BLUE};
  }
`;

const columnSizing = "150px 300px 1fr 1fr";

const renderService = service => {
  const job = service.job;
  const { contact, franchise } = job;
  const contactName = contactDisplayName(contact);
  const link = `/admin/jobs/${job.id}/services/${service.id}`;

  return (
    <TableRow key={service.id} columns={columnSizing}>
      <TableCell>
        <StyledLink to={link}>{job.contractNumber}</StyledLink>
      </TableCell>
      <TableCell>
        <StyledLink to={link}>{contactName}</StyledLink>
      </TableCell>
      <TableCell>
        <Moment format="MMM D, YYYY [at] h:mm a">{service.submittedAt}</Moment>
      </TableCell>
      <TableCell>{franchise && franchise.name}</TableCell>
    </TableRow>
  );
};

class ReviewQueue extends React.Component {
  componentDidMount() {
    if (this.props.data) {
      this.props.data.refetch();
    }
  }

  render() {
    if (this.props.data) {
      const { loading, services } = this.props.data;

      if (loading && !services) {
        return <CenteredLoader />;
      }

      if (!services || !services.length) {
        return (
          <EmptyMessage>It looks like the review queue is empty!</EmptyMessage>
        );
      }

      return (
        <Table>
          <TableRow header columns={columnSizing}>
            <TableCell>Contract #</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Submitted At</TableCell>
            <TableCell>Franchise</TableCell>
          </TableRow>
          {services.map(renderService)}
        </Table>
      );
    }

    return null;
  }
}

const ReviewQueueQuery = gql`
  query ReviewQueueQuery {
    services(queue: "review") {
      id
      serviceType
      submittedAt
      job {
        id
        contractNumber
        contact {
          id
          firstName
          lastName
          otherFirstName
          otherLastName
        }
        franchise {
          id
          name
        }
      }
    }
  }
`;

export default graphql(ReviewQueueQuery, {
  options: { pollInterval: 1000 * 30 }
})(ReviewQueue);



// WEBPACK FOOTER //
// ./src/components/admin/Dashboard/ReviewQueue.js